export const authConfig = {
  region: process.env.NEXT_PUBLIC_NCP_COGNITO_REGION || '',
  userPoolId: process.env.NEXT_PUBLIC_NCP_COGNITO_USER_POOL_ID || '',
  userPoolClientId: process.env.NEXT_PUBLIC_NCP_COGNITO_CLIENT_ID || '',
}

export function hasCognitoConfig() {
  return Boolean(authConfig.region && authConfig.userPoolId && authConfig.userPoolClientId)
}
